// React
import React from 'react';
import {
  Card,
  CardBody,
  Col,
  Form,
  Label,
  Row,
  Input,
  CardFooter,
} from 'reactstrap';

// Containers Injection
import {
  PageWrapper,
  SelectInput,
  convertEventSelectToTarget,
} from '../../containers/componentsInjection';

export const ProposalsBySellerPage = ({
  history,
  sellers,
  createData,
  validation,
  categoryPlans,
  organizations,
  statusOptions,
  departmentOptions,
  dataCadastralStatus,
  resetDepartmentInput,
}) => {
  return (
    <PageWrapper title="Propostas por Corretor">
      <Row>
        <Col xxl={12}>
          <Card>
            {/* <CardBody className="p-4"> */}
            <Form
              autoComplete="off"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <CardBody>
                <Row>
                  <Col md={12}>
                    {/* <div className="mb-3">
                        <h5>Filtros</h5>
                      </div> */}
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label className="form-label">Período por</Label>
                      <div className="d-flex justify-content-between align-items-center">
                        <Col>
                          <Input
                            id="periodTypeSale"
                            name="periodType"
                            className="me-2"
                            type="radio"
                            value={'sale'}
                            onBlur={validation.handleBlur}
                            checked={validation.values.periodType === 'sale'}
                            onChange={(e) => {
                              if (e.target.value === 'sale') {
                                validation.handleChange({
                                  target: {
                                    name: 'periodType',
                                    value: 'sale',
                                  },
                                });
                              }
                            }}
                          />
                          <Label
                            htmlFor="periodTypeSale"
                            className="text-muted text-uppercase"
                          >
                            Data da Venda
                          </Label>
                        </Col>
                        <Col>
                          <Input
                            id="periodTypeCreated"
                            name="periodType"
                            className="me-2"
                            type="radio"
                            value={'created'}
                            onBlur={validation.handleBlur}
                            checked={validation.values.periodType === 'created'}
                            onChange={(e) => {
                              if (e.target.value === 'created') {
                                validation.handleChange({
                                  target: {
                                    name: 'periodType',
                                    value: 'created',
                                  },
                                });
                              }
                            }}
                          />
                          <Label
                            htmlFor="periodTypeCreated"
                            className="text-muted text-uppercase"
                          >
                            Data da Vigência
                          </Label>
                        </Col>
                      </div>
                    </div>
                  </Col>
                  <Col md={4} className="mb-3">
                    <div>
                      <Label for="saleAtInput" className="form-label">
                        Período
                      </Label>
                      <div className="d-flex justify-content-center align-items-center">
                        <Input
                          type="date"
                          id="periodStarts"
                          value={validation.values.periodStarts}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                        />
                        <span className="m-2">a</span>
                        <Input
                          type="date"
                          id="periodEnds"
                          value={validation.values.periodEnds}
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label htmlFor="sellerInput" className="form-label">
                        Corretor
                      </Label>
                      <SelectInput
                        isClearable
                        inputId="sellerInput"
                        value={validation.values.sellerInput}
                        className="form-control"
                        onChange={(eventInput) => {
                          validation.handleChange(
                            convertEventSelectToTarget(
                              'sellerInput',
                              eventInput
                            )
                          );
                          if (!eventInput) {
                            validation.handleChange({
                              target: {
                                name: 'sellerInput',
                                value: {
                                  label: '',
                                  value: '',
                                },
                              },
                            });
                          }
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'sellerInput',
                              eventInput
                            )
                          );
                        }}
                        options={createData(sellers)}
                        placeholder="Todos"
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label htmlFor="categoryPlanInput" className="form-label">
                        Categoria de Plano
                      </Label>
                      <SelectInput
                        multiple={true}
                        className="form-control"
                        inputId="categoryPlanInput"
                        value={validation.values.categoryPlanInput}
                        onChange={(eventInput) => {
                          validation.handleChange(
                            convertEventSelectToTarget(
                              'categoryPlanInput',
                              eventInput
                            )
                          );
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'categoryPlanInput',
                              eventInput
                            )
                          );
                        }}
                        options={createData(categoryPlans)}
                        placeholder="Todas"
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label
                        htmlFor="proposalSituationInput"
                        className="form-label"
                      >
                        Situação da Proposta
                      </Label>
                      <SelectInput
                        multiple={true}
                        className="form-control"
                        inputId="proposalSituationInput"
                        value={validation.values.proposalSituationInput}
                        onChange={(eventInput) => {
                          validation.handleChange(
                            convertEventSelectToTarget(
                              'proposalSituationInput',
                              eventInput
                            )
                          );
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'proposalSituationInput',
                              eventInput
                            )
                          );
                        }}
                        options={statusOptions}
                        placeholder="Todos"
                      />
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="organizationInput">
                        Organização
                      </Label>
                      <SelectInput
                        isClearable
                        inputId="organizationInput"
                        value={validation.values.organizationInput}
                        className="form-control"
                        onChange={(eventInput) => {
                          resetDepartmentInput();
                          if (!eventInput) {
                            validation.handleChange({
                              target: {
                                name: 'organizationInput',
                                value: {
                                  label: '',
                                  value: '',
                                },
                              },
                            });
                          } else {
                            validation.handleChange(
                              convertEventSelectToTarget(
                                'organizationInput',
                                eventInput
                              )
                            );
                          }
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'organizationInput',
                              eventInput
                            )
                          );
                        }}
                        options={createData(organizations)}
                        placeholder="Todas"
                      />
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="departmentInput">
                        Lotação
                      </Label>
                      <SelectInput
                        isDisabled={!validation.values.organizationInput.value}
                        inputId="departmentInput"
                        value={validation.values.departmentInput}
                        className="form-control"
                        onChange={(eventInput) => {
                          validation.handleChange(
                            convertEventSelectToTarget(
                              'departmentInput',
                              eventInput
                            )
                          );
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'departmentInput',
                              eventInput
                            )
                          );
                        }}
                        options={departmentOptions}
                        placeholder="Todas"
                      />
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="mb-3">
                      <Label
                        htmlFor="employeeSituationInput"
                        className="form-label"
                      >
                        Situação do Empregado
                      </Label>
                      <SelectInput
                        multiple={true}
                        className="form-control"
                        inputId="employeeSituationInput"
                        value={validation.values.employeeSituationInput}
                        onChange={(eventInput) => {
                          validation.handleChange(
                            convertEventSelectToTarget(
                              'employeeSituationInput',
                              eventInput
                            )
                          );
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'employeeSituationInput',
                              eventInput
                            )
                          );
                        }}
                        options={dataCadastralStatus}
                        placeholder="Todas"
                      />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <Col md={12}>
                  <div className="text-end d-flex btn-link justify-content-end">
                    <button
                      type="button"
                      className="btn btn-link"
                      style={{
                        marginRight: '10px',
                      }}
                      onClick={() => {
                        history.push('/relatorios');
                      }}
                    >
                      Voltar
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Gerar Relatório
                    </button>
                  </div>
                </Col>
              </CardFooter>
            </Form>
            {/* </CardBody> */}
          </Card>
        </Col>
      </Row>
    </PageWrapper>
  );
};
